import router from "./router";

router.beforeEach((to, from, next) => {
  next();
});

router.afterEach((to) => {
  document.title = to.meta.title;
});
